import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoopBackAuth, UserDataApi } from '../../assets/js/lb-sdk/services';
import { Observable } from 'rxjs';

@Injectable()
export class Authentication implements CanActivate {
  constructor(
    private loopBackAuth: LoopBackAuth,
    private userDataApi: UserDataApi,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return new Observable<boolean>(subsriber => {
      this.userDataApi
        .getCurrent()
        .subscribe(user => {
          if (!user) {
            this.router.navigate(['/401']);
            subsriber.next(false);
          } else {
            subsriber.next(true);
          }
          subsriber.complete();
        }, error => {
          if (error.statusCode === 401) {
            this.router.navigate(['/401']);
            subsriber.next(false);
          } else {
            subsriber.next(true);
          }
          subsriber.complete();
        });
    });
  }
}
